import Vue from 'vue'
import Router from 'vue-router'
import { routes } from './const'
import store from '@/store'

Vue.use(Router)

let menus = []
routes.forEach(menu => {
  let obj = {}
  let arr = []
  obj.path = menu.path
  obj.name = menu.name
  obj.component = () => import(/* webpackChunkName: `${menu.name}` */ `../pages${menu.filePath}`)
  menu.subPathes.forEach(sub => {
    let subItem = {}
    subItem.path = sub.path
    subItem.name = sub.name
    subItem.component = () => import(/* webpackChunkName: sub.name */ `../pages${sub.filePath}`)
    subItem.meta = {
      index: sub.index,
      url: sub.isIframe && sub.iframeUrl ? sub.iframeUrl : '',
      host: sub.isIframe ? sub.iframeHost ? sub.iframeHost : 'supplyUrl' : ''
    }
    arr.push(subItem)
  })
  obj.children = arr
  menus.push(obj)
})

const router = new Router({
  routes: [
    {
      path: '/selectSupplier',
      name: 'selectSupplier',
      component: require('@/pages/selectSupplier').default
    },
    {
      path: '/supplierPoolInfo',
      name: 'supplierPoolInfo',
      component: require('@/pages/supplierPool/pc/info').default
    },
    {
      path: '/supplierPoolGuide',
      name: 'supplierPoolGuide',
      component: require('@/pages/supplierPool/pc/guide').default
    },
    {
      path: '/',
      name: 'main',
      // redirect: '/order/notConfirmed', // TODO
      component: () => import(/* webpackChunkName: "order" */ `../pages/main`),
      children: [
        ...menus
      ]
    },
    {path: '/404', name: 'error404', component: resolve => require.ensure([], () => resolve(require('@/pages/error/404').default), 'error404')},
    {path: '*', redirect: '/404'},
    {path:'/download/downloadApp', redirect:'https://www.baidu.com'}
  ]
})

router.afterEach((to, from) => {
  if (to.meta && to.meta.index) {
    if (!store.state.isJiajiayuan && to.meta.index === '/order/checkAndAcceptOrder') { // 在入库验收单tab下 切换供应商,默认跳转到待确认tab下
      store.commit('setActiveMenu', '/order/notConfirmed')
    } else {
      store.commit('setActiveMenu', to.meta.index)
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js